import { useLayoutEffect } from "react";

export const useClientLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : () => {};
